import React, { memo, Fragment } from 'react'
import { IBand } from 'apps/marketplace/store/contractLanes/types'
import { RADIUS_RATE, updateRadiusRate } from 'apps/marketplace/utils/constants/rates'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'
import { TextInput } from 'components/atoms'
import { Checkbox } from 'components/forms'

interface IRadiusRates {
  rateType: string
  radiusRates: IBand[]
  onChange: (arg: Partial<ChangeRateData>) => void
}

export const RadiusRates = memo<IRadiusRates>(({ onChange, radiusRates, rateType }) => {
  if (rateType !== RADIUS_RATE) {
    return <></>
  }

  const radiusRateToggleHandler = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, id } = target
    onChange({
      radiusRates: updateRadiusRate(radiusRates, id, { checked }),
    })
  }

  const radiusRateValueHandler = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = target
    onChange({
      radiusRates: updateRadiusRate(radiusRates, id, { value }),
    })
  }

  return (
    <div className='row'>
      <div className='col-xs-12'>
        <div className='pv2'>
          <legend className='label required'>Deliver anywhere within:</legend>
        </div>
        {radiusRates.map(({ checked, max, min, value }) => (
          <Fragment key={`${min}-${max}`}>
            <div className='row'>
              <div className='col-md-4'>
                <Checkbox
                  id={`radius-range-${min}-${max}`}
                  dataTest={`radius-range-${min}-${max}`}
                  label={`${min} - ${max} mi`}
                  checked={checked}
                  onChange={radiusRateToggleHandler}
                />
              </div>
            </div>
            {checked && (
              <div className='row'>
                <div className='col-md-2'>
                  <TextInput
                    id={`radius-rate-${min}-${max}`}
                    type='number'
                    value={value}
                    onChange={radiusRateValueHandler}
                    dataTest={`radius-rate-${min}-${max}`}
                    placeholder='$'
                    min='0'
                  />
                </div>
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
})
